var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.013 6.89a.75.75 0 0 1 .75.75v5.299a.75.75 0 0 1-1.5 0v-5.3a.75.75 0 0 1 .75-.75Z",
    className: "accent"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.737 7.64a.75.75 0 0 0-1.5 0v5.299a.75.75 0 0 0 1.5 0v-5.3Z",
    className: "accent"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.013.265A2.075 2.075 0 0 0 4.938 2.34v.575H1.713a.75.75 0 0 0 0 1.5h.575V16.25A1.413 1.413 0 0 0 3.7 17.663h10.6a1.413 1.413 0 0 0 1.412-1.412V4.415h.575a.75.75 0 0 0 0-1.5h-3.225V2.34A2.075 2.075 0 0 0 10.987.265H7.013Zm5.297 4.15h1.902v11.748H3.788V4.415h8.522Zm-.748-1.5V2.34a.575.575 0 0 0-.575-.575H7.013a.575.575 0 0 0-.575.575v.575h5.124Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.be40b5fbe3685f5c6463c9e234c08cf8.svg";
export { ForwardRef as ReactComponent };